export default __webpack_public_path__ + "8fc8ba74ec63d56cf6e36b9d36452592.png";